const safeParse = value => {
    try {
        return JSON.parse(value)
    } catch (error) {
        console.warn('Error parsing JSON:', error)
        return null
    }
}

const safeStringify = value => {
    try {
        return JSON.stringify(value)
    } catch (error) {
        console.warn('Error stringifying JSON:', error)
        return null
    }
}

export { safeParse, safeStringify }
